import React, { useMemo } from 'react';
import MenuProvider from './providers/MenuProvider';
import OngoingOrderProvider from './providers/OngoingOrderProvider';
import AuthProvider from './providers/AuthProvider';
import Router from './routing/Router';
import { ConfigProvider } from 'antd';
import theme from './assets/styles/theme';
import StoreProvider from './providers/StoreProvider';
import { Libraries, useLoadScript } from '@react-google-maps/api';
import OrderBasketProvider from './providers/OrderBasketProvider';
import OngoingCallProvider from './providers/OngoingCallProvider';
import NotificationProvider from './providers/NotificationProvider';
import ForceRenderProvider from './providers/ForceRenderProvider';
import moment from 'moment-timezone';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import * as Sentry from '@sentry/react';
import ErrorPage from './pages/other/ErrorPage';
import CustomerDetailsProvider from './providers/CustomerDetailsProvider';

export const TIMEZONE = 'Europe/Berlin';

moment.tz.setDefault(TIMEZONE);
dayjs.extend(utc);

const libraries = ['places', 'geometry'];

export default function App() {
  useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries: libraries as Libraries,
  });

  const antTheme = useMemo(
    () => ({
      token: {
        colorPrimary: theme.color.brand.primary,
        fontFamily: 'Inter',
        colorBorder: theme.color.gray.DEFAULT,
      },
    }),
    [],
  );

  return (
    <ConfigProvider theme={antTheme}>
      <Sentry.ErrorBoundary fallback={<ErrorPage />}>
        <ForceRenderProvider>
          <NotificationProvider>
            <AuthProvider>
              <StoreProvider>
                <CustomerDetailsProvider>
                  <OngoingOrderProvider>
                    <OngoingCallProvider>
                      <MenuProvider>
                        <OrderBasketProvider>
                          <Router />
                          <div id="vox-kit-softphone" className="z-10" />
                        </OrderBasketProvider>
                      </MenuProvider>
                    </OngoingCallProvider>
                  </OngoingOrderProvider>
                </CustomerDetailsProvider>
              </StoreProvider>
            </AuthProvider>
          </NotificationProvider>
        </ForceRenderProvider>
      </Sentry.ErrorBoundary>
    </ConfigProvider>
  );
}
